// extracted by mini-css-extract-plugin
export default {"light-cta":"y0Gu30","lightCta":"y0Gu30","new-ui-footer":"viXyPv","newUiFooter":"viXyPv","arrow-btn-rotate":"UVhikK","arrowBtnRotate":"UVhikK"};